// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"jO","logoWrapper":"jP"};